import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { ContentBox, TextInput, FormButtons, FormError, PortalForm } from '@portal/kit/pkg/components'

const EditNameForm = ({ handleSubmit, submitError, t }) => (
  <ContentBox title={t('account.edit_my_name')}>
    <PortalForm onSubmit={handleSubmit}>
      {
        submitError && <FormError message={submitError} />
      }
      <TextInput name="first_name" label={t('account.firstname')} />
      <TextInput name="last_name" label={t('account.lastname')} />
      <FormButtons cancel="/my-account" submit />
    </PortalForm>
  </ContentBox>
)

EditNameForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitError: PropTypes.string,
}

export default withTranslation()(EditNameForm)
